import { createContext } from "react";

interface ISubscriptionContext {
  showSubscriptionModalCallback?: (value: boolean) => void;
}

interface ICartContext {
  cartData: any;
}

export const CatalogSettingContext = createContext({});
export const SubscriptionModalContext = createContext<ISubscriptionContext>({});
export const RouterCartContext = createContext<ICartContext>({ cartData: null });
